import { Popper, Fade, Paper, Typography } from '@material-ui/core';
import { useRef, useEffect } from 'react';

const popperStyle = {
  maxWidth: '400px',
  zIndex: '1001',
};

export default function Qpopper(props) {
  function useOutSideClickListener(ref) {
    function handleClickOutside(event) {
      if (
        props.anchorEl &&
        ref.current &&
        !(
          ref.current.contains(event.target) ||
          event.target.nodeName == 'svg' ||
          (props.preventCloseForText &&
            event.target.textContent &&
            event.target.textContent.includes(props.preventCloseForText))
        )
      ) {
        if (props.useDelayForClosing) {
          setTimeout(() => {
            // for links to get triggered before closing popper
            props.setAnchor(null);
          }, 500);
        } else {
          props.setAnchor(null);
        }
      }
    }

    useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    });
  }
  const { anchorEl, placement, children } = props;
  const wrapperRef = useRef(null);
  useOutSideClickListener(wrapperRef);
  return (
    <div ref={wrapperRef}>
      <Popper style={popperStyle} open={!!anchorEl} anchorEl={anchorEl} placement={placement} transition>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper>
              <Typography>{children}</Typography>
            </Paper>
          </Fade>
        )}
      </Popper>
    </div>
  );
}
